/* eslint-disable no-undef */
import { useConfiguratorStore } from "@/stores/configurator";
export default function useScrollEventListeners() {
  const $eventBus = inject('bus');
  const configuratorStore = useConfiguratorStore();
  const {
    canvasContainerScale,
    minVisibleFraction
  } = storeToRefs(configuratorStore);
  const canvasContainer = document.querySelector('.canvas-container');
  const workspace = document.querySelector('#workspace');
  const INVERT_MOUSE_WHEEL = ref(-1);
  function calculateContainerX(event) {
    const startCanvasPos = canvasContainer.offsetLeft;
    const containerSize = canvasContainer.offsetWidth;
    const workspaceSize = workspace.offsetWidth;
    const scaledSize = containerSize * canvasContainerScale.value;
    const visible = workspaceSize * minVisibleFraction.value;
    const delta = event['deltaX'];
    let position = startCanvasPos + delta * INVERT_MOUSE_WHEEL.value;
    const offset = (containerSize - scaledSize) / 2;
    if (position > workspaceSize - offset - visible) {
      position = workspaceSize - offset - visible;
    }
    if (position < -(scaledSize + offset) + visible) {
      position = -(scaledSize + offset) + visible;
    }
    return position;
  }
  function calculateContainerY(event) {
    const startCanvasPos = canvasContainer.offsetTop;
    const containerSize = canvasContainer.offsetHeight;
    const workspaceSize = workspace.offsetHeight;
    const scaledSize = containerSize * canvasContainerScale.value;
    const visible = workspaceSize * minVisibleFraction.value;
    const delta = event['deltaY'];
    let position = startCanvasPos + delta * INVERT_MOUSE_WHEEL.value;
    const offset = (containerSize - scaledSize) / 2;
    if (position > workspaceSize - offset - visible) {
      position = workspaceSize - offset - visible;
    }
    if (position < -(scaledSize + offset) + visible) {
      position = -(scaledSize + offset) + visible;
    }
    return position;
  }
  function setCanvasContainerPosition(event) {
    const canvasContainerLeft = calculateContainerX(event);
    const canvasContainerTop = calculateContainerY(event);
    window.requestAnimationFrame(() => {
      canvasContainer.style.left = canvasContainerLeft + 'px';
      canvasContainer.style.top = canvasContainerTop + 'px';
    });
  }
  const handleScroll2dEditorMovement = event => {
    event.preventDefault();
    setCanvasContainerPosition(event);
  };
  $eventBus.$on('scroll-movement', handleScroll2dEditorMovement);
  $eventBus.$on('scroll-movement-v', event => handleScroll2dEditorMovement(event, 'vertical'));
  $eventBus.$on('scroll-movement-h', event => handleScroll2dEditorMovement(event, 'horizontal'));
}